<template>
  <span fluid>
    <v-card class="card--flex-toolbar">
      <v-card-title class="blue-grey lighten-5">
        <h2>Cadastro de Usuários e Fornecedores</h2>
        <v-spacer></v-spacer>
        <v-btn @click="onNewButtonClick()" small color="primary">Novo</v-btn>
      </v-card-title>
      <v-card-text>
        <e-data-table
          :headers="headers"
          :items="uf"
          :total="total"
          @refresh="getAll"
          @edit="editItem"
          @delete="deleteItem"
        ></e-data-table>
      </v-card-text>
      <v-card-actions></v-card-actions>
    </v-card>
  </span>
</template>
<script>
import usuariosfornecedoresService from '@/services/usuariosfornecedores'
import EDataTable from '@/components/EDataTable'
import { showError, showConfirm, retPermissao } from '@/utils'

export default {
  name: 'usuariosfornecedores',
  components: {
    EDataTable
  },
  data () {
    return {
      uf: [],
      total: 0,
      headers: [
        { text: 'Usuário', value: 'usuario', sortable: false },
        { text: 'Ativo', value: 'ativo', sortable: false }],
      valid: true,
      rules: {
        nome: [v => !!v || 'Campo Requerido'],
        ativo: [v => !!v || 'Campo Requerido']
      },
      buttonSaveLoadingVisible: false
    }
  },

  methods: {
    async getAll (page, search) {
      try {
        this.loading = true
        const result = search === '' ? await usuariosfornecedoresService.getAll(page) : await usuariosfornecedoresService.getByNome(search, page)
        this.total = result._meta.total_items
        this.uf = result.data
        this.loading = false
      } catch (error) {
        this.uf = []
        showError(error)
      }
    },
    editItem (item) {
      this.$router.push(`/usuariosfornecedores/editar/${item.id}`)
    },
    async deleteItem (item) {
      var ret = retPermissao('Usuários Fornecedores', 'excluir')
      if (ret === true) {
        showConfirm(`Tem certeza que deseja remover relacionamento ?`, async result => {
          if (result) {
            try {
              this.loading = true
              await usuariosfornecedoresService.delete(item.id)
              this.getAll(1, '')
            } catch (error) {
              showError(error)
            } finally {
              this.loading = false
            }
          }
        })
      }
    },
    onNewButtonClick () {
      this.$router.push(`/usuariosfornecedores/criar`)
    }
  }
}
</script>
